module.exports = __webpack_public_path__ + "static/img/cont33_06.15765b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont33_06.jpg
// module id = 0pAa
// module chunks = 0